// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import HomePage from "./HomePage";
// import TutorPage from "./TutorPage";
// import StudentPage from "./StudentPage";
// import AdministratorPage from "./AdministratorPage";
// const RouterMain = () => {
//   return (
//     <div>
//       {/* <ScrollToTop/> */}
//       <Routes>
//        <Route path="/" element={<HomePage />} />
//         <Route path="/tutor" element={<TutorPage/>} />
//         <Route path="/student" element={<StudentPage/>} />
//         <Route path="/administrator" element={<AdministratorPage/>} />
//       </Routes>
//     </div>
//   );
// };

// export default RouterMain;

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import TutorPage from "./TutorPage";
import StudentPage from "./StudentPage";
import AdministratorPage from "./AdministratorPage";
import RootPage from "./RootPage";
import MyMarqueeAdmin from "./MarqueeAdmin";
import UploadFile from "./UploadFile";
import PanelPage from "./PanelPag";
import UploadImages from "./UploadImages";
import AddSubscriber from "./AddSubscriber";
const RouterMain = () => {
  return (
    <div>
      {/* <ScrollToTop/> */}
      <Routes>
        <Route path="/" element={<RootPage/>} />
        <Route path="/marquee" element={<MyMarqueeAdmin />} />
        <Route path="/carousel" element={<UploadFile />} />
        <Route path="/panel" element={<PanelPage />} />

        <Route path="/images" element={<UploadImages />} />
          <Route path="/subscriber" element={<AddSubscriber/>} />
        
      </Routes>
    </div>
  );
};

export default RouterMain;
